// extracted by mini-css-extract-plugin
export default {"CardGrid":"SuggestedItems_CardGrid__2ZiV7","Card":"SuggestedItems_Card__inkcA","CardImage":"SuggestedItems_CardImage__962Tf"};